import { apiClient } from "./ApiClient";

export async function fetchNotificationsAdmin({ offset = 0, limit = 20, filters = {} }) {
  const params = new URLSearchParams({
    offset: offset.toString(),
    limit: limit.toString(),
  });

  for (const key in filters) {
    if (filters[key] !== null && filters[key] !== "") {
      params.append(key, filters[key]);
    }
  }

  try {
    const response = await apiClient.get(`/notification/batch/admin?${params}`);

    return {
      items: response.data.items || response.data || [],
      total: response.data.total || response.data.count || response.data.items?.length || response.data.length || 0, // prawdziwy total
      filtered: response.data.filtered || response.data.items?.length || 0,
    };
  } catch (error) {
    const errorData = error.response?.data || {};
    const status = error.response?.status || error.request?.status || 500;

    const err = new Error(errorData.detail || `Failed to fetch notifications`);
    err.status = status;
    err.response = { status, data: errorData };
    throw err;
  }
}

export async function createNotificationForUser(token, { name, description, type, user_id }) {
  return apiClient.post(`/notification/user/${user_id}`, {
    name,
    description,
    type,
  });
}

export async function createNotificationForRole(token, { name, description, type, role_id }) {
  return apiClient.post(`/notification/role/${role_id}`, {
    name,
    description,
    type,
  });
}

export async function createNotificationForAll(token, { name, description, type }) {
  return apiClient.post("/notification/", { name, description, type });
}

export async function updateNotification({ notification_id, data }) {
  try {
    const response = await apiClient.put(`/notification/${notification_id}`, data);
    return response.data;
  } catch (error) {
    const errorData = error.response?.data || {};
    const status = error.response?.status || error.request?.status || 500;

    const err = new Error(errorData.detail || "Failed to update notification");
    err.status = status;
    err.response = { status, data: errorData };
    throw err;
  }
}

export async function deleteNotificationForUser(notification_id) {
  try {
    const response = await apiClient.delete(`/notification/${notification_id}`);
    return response.data;
  } catch (error) {
    const errorData = error.response?.data || {};
    const status = error.response?.status || error.request?.status || 500;

    const err = new Error(errorData.detail || "Failed to delete notification");
    err.status = status;
    err.response = { status, data: errorData };
    throw err;
  }
}

export async function deleteNotificationForAll(notification_id) {
  try {
    const response = await apiClient.delete(`/notification/all/${notification_id}`);
    return response.data;
  } catch (error) {
    const errorData = error.response?.data || {};
    const status = error.response?.status || error.request?.status || 500;

    const err = new Error(errorData.detail || "Failed to delete notification for all");
    err.status = status;
    err.response = { status, data: errorData };
    throw err;
  }
}
